export const Unit = [
    {
      id: "1",
      enable:1,
      code: "U001",
      name: "kg"
    },
    {
      id: "2",
      enable:1,
      code: "U002",
      name: "L"
    },
    {
      id: "3",
      enable:1,
      code: "U003",
      name: "NOs"
    },
  ];